import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ProjectService } from '../../services/project.service';
import moment from 'moment';
import { ReportsService } from "../../services/reports.service";
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const filterActions = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const recordActions = writable(null);
export const recordsActions = writable([]);
export const paginationActions = writable(null);
export const tasks = writable([]);
export const showModal = writable(false);
export const modalData = writable(null);
export const showModalAction = writable(false);
export const modalDataAction = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    recordActions.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    recordActions.set(null);
    showModal.set(false);
    modalData.set(null);
    if (oid == 0) {
        record.set(null);
        paginationActions.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    }
    else {
        let _resp = await ProjectService.fetchProject(oid).toPromise();
        let r = _resp.payload;
        r.azionifiltered = r.azioni;
        record.set(_resp.payload);
        resetSearchFilterAction();
        paginationActions.set({ currentPage: 1, totalPages: Math.ceil(_resp.payload.azionifiltered.length / 10), totalRecords: _resp.payload.azionifiltered.length });
        recordsActions.set(_resp.payload.azionifiltered.slice(0, 10));
        computeTasks(r.azionifiltered);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function clearSearch() {
    resetSearchFilter();
    search();
}
export function resetSearchFilter() {
    filter.set({ criteria: {}, params: null, sorting: "" });
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ProjectService.getProjects(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function createNewAction() {
    const currentProject = get(record);
    if (!currentProject)
        return;
    const newAction = {
        origin: 'CRM',
        oid: currentProject.oid,
        codiceCommessa: Number(currentProject.oid),
        stato: '',
        gestioneSeparata: '',
        codiceProgetto: currentProject.progetto.codiceProgetto || '',
        titolo: '',
        descrizioneAzione: '',
        iDAzioneFIMAA39: '',
        hub: '',
        riferimentoNote: '',
        ore: 0,
        tipologiaOre: '',
        descrTipoIntervento: '',
        uffcompetenza: '',
        statoazione: '',
        pianificato: 0,
        erogato: 0,
        annullato: '',
        partecipantiAttesi: 0,
        costoStandard1: 0,
        costoStandard2: 0,
        budget: 0,
        monitoraggioEffettuato: '',
        oreFinali: 0,
        partecipantiFinali: 0,
        totalerendicontato: 0,
        tipoRendiconto: '',
        decurtazione: 0,
        dataStato: null,
        dataFine: null,
        dataInizio: null,
        ragsoc1: '',
        ragsoc2: '',
        ragsoc3: '',
        ragsoc4: '',
        ragsoc5: '',
        ragsoc6: ''
    };
    modalDataAction.set(newAction);
    showModalAction.set(true);
}
export async function saveAction(action) {
    var _a;
    loading.set(true);
    try {
        const resp = await ProjectService.saveProjectAction(action).toPromise();
        if (!((_a = resp.issue) === null || _a === void 0 ? void 0 : _a.error)) {
            // Refresh current project's actions after save
            const currentProject = get(record);
            if (currentProject) {
                const fullProject = await ProjectService.fetchProject(Number(currentProject.oid)).toPromise();
                const projectPayload = fullProject.payload;
                projectPayload.azionifiltered = projectPayload.azioni;
                record.set(projectPayload);
                paginationActions.set({
                    currentPage: 1,
                    totalPages: Math.ceil(projectPayload.azionifiltered.length / 10),
                    totalRecords: projectPayload.azionifiltered.length,
                });
                recordsActions.set(projectPayload.azionifiltered.slice(0, 10));
            }
            showModalAction.set(false);
        }
        return resp;
    }
    finally {
        loading.set(false);
    }
}
export async function deleteAction(action) {
    var _a;
    loading.set(true);
    try {
        const resp = await ProjectService.deleteProjectAction(action).toPromise();
        if (!((_a = resp.issue) === null || _a === void 0 ? void 0 : _a.error)) {
            // Refresh current project's actions after save
            const currentProject = get(record);
            if (currentProject) {
                const fullProject = await ProjectService.fetchProject(Number(currentProject.oid)).toPromise();
                const projectPayload = fullProject.payload;
                projectPayload.azionifiltered = projectPayload.azioni;
                record.set(projectPayload);
                paginationActions.set({
                    currentPage: 1,
                    totalPages: Math.ceil(projectPayload.azionifiltered.length / 10),
                    totalRecords: projectPayload.azionifiltered.length,
                });
                recordsActions.set(projectPayload.azionifiltered.slice(0, 10));
            }
            showModalAction.set(false);
        }
        return resp;
    }
    finally {
        loading.set(false);
    }
}
export function onEdit(item) {
    navigate(`/project/${item.oid}`);
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export function onPageChangeProjectAction(pageNumber) {
    paginationActions.set(Object.assign(Object.assign({}, get(paginationActions)), { currentPage: pageNumber }));
    const rec = get(record);
    const startIndex = (pageNumber - 1) * 10;
    const endIndex = startIndex + 10;
    recordsActions.set(rec.azionifiltered.slice(startIndex, endIndex));
}
export function searchAction() {
    let rec = get(record);
    rec.azionifiltered = applyFilterActions();
    record.set(rec);
    paginationActions.set({ currentPage: 1, totalPages: Math.ceil(rec.azionifiltered.length / 10), totalRecords: rec.azionifiltered.length });
    recordsActions.set(rec.azionifiltered.slice(0, 10));
    computeTasks(rec.azionifiltered);
}
export function clearSearchAction() {
    resetSearchFilterAction();
    searchAction();
}
export function resetSearchFilterAction() {
    filterActions.set({ criteria: {}, params: null, sorting: "" });
}
function computeTasks(actions) {
    let t = [];
    actions.forEach(x => {
        if (x.dataInizio != null) {
            let v = {
                id: x.codiceAzione.toString(),
                name: x.descrizioneAzione,
                start: x.dataInizio,
                end: x.dataFine == null ? moment().add(1, 'year').toDate() : x.dataFine,
                progress: x.pianificato == 0 ? 0 : (x.erogato / x.pianificato) * 100
            };
            t.push(v);
        }
    });
    tasks.set(t);
}
function applyFilterActions() {
    let rec = get(record);
    let filt = get(filterActions);
    let res = [];
    let finizio = filt.criteria.dataFrom == null ? null : moment(filt.criteria.dataFrom);
    let ffine = filt.criteria.dataTo == null ? null : moment(filt.criteria.dataTo);
    for (let i = 0; i < rec.azioni.length; i++) {
        let r = rec.azioni[i];
        if (filt.criteria.query != null
            && r.descrizioneAzione.indexOf(filt.criteria.query) < 0)
            continue;
        if (filt.criteria.stato != null
            && r.statoazione != filt.criteria.stato)
            continue;
        if (finizio != null
            && moment(r.dataInizio).isBefore(finizio))
            continue;
        if (ffine != null
            && moment(r.dataInizio).isBefore(ffine))
            continue;
        res.push(r);
    }
    return res;
}
export function onExportProjects() {
    let _filter = get(filter);
    ReportsService.exportExcelProjects(_filter);
}
export function onExportProjectActions() {
    let _filter = get(filterActions);
    let rec = get(record);
    _filter.criteria.titolo = rec.progetto.titoloProgetto;
    ReportsService.exportExcelProjectActions(_filter);
}
export function showDetailAction(item) {
    showModal.set(true);
    modalData.set(item);
}
